import React, { useCallback, useEffect } from "react";
import { FormLoginScheme } from "../../../Models/Schemas/form-login";
import { FORM_LOGIN } from "../../../Constants/Login";
import Button from "../../Elements/Button/Button";
import { setErrorFormSimpleUtil } from "../../../Utilities/Forms/errors";
import useForm from "../../../Hooks/useForm";
import Input from "../../Elements/Input/Input";
import Loader from "../../Elements/Loader/Loader";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";
import './login.css';

const Login = () => {
  const showToast = useToast();
  const {
    fetchDataLogin,
    loginLoading: loading,
    loginError: error,
  } = useStore();

  const { values, errors, touched, handleBlur, handleChange, isValid } =
    useForm(FORM_LOGIN, FormLoginScheme);

  const submit = () => {
    sendLoginData();
  };

  const sendLoginData = () => {
    if (values) {
      fetchDataLogin(values);
    }
  };

  const handleResponse = useCallback(() => {
    if (error) {
      const message =
        error instanceof Error ? error.message : error?.error || "Error desconocido";
      showToast("error", message);
    }
  }, [error, showToast]);

  useEffect(() => {
    handleResponse();
  }, [handleResponse]);

  if (loading) {
    return <Loader />
  }

  return (
    <div className="login-wrapper">
      <div className="form-login">
        <div className="login-header">
          <img
            src="https://cms.qualityseal.com.mx/contenido/uploads/logo_0b73df3fcc.png"
            alt="Quality Seal"
            className="login-logo"
          />
          <h1>Producción</h1>
          <p className="login-subtitle">Inicia sesión para continuar</p>
        </div>

        <form className="login-form-fields" autoComplete="off">
          <Input
            mask=""
            value={values.username}
            label="Usuario"
            onChange={handleChange("username")}
            onBlur={handleBlur("username")}
            error={setErrorFormSimpleUtil(errors, touched, "username")}
            success={!setErrorFormSimpleUtil(errors, touched, "username")}
          />
          <Input
            value={values.password}
            label="Contraseña"
            onChange={handleChange("password")}
            onBlur={handleBlur("password")}
            error={setErrorFormSimpleUtil(errors, touched, "password")}
            success={!setErrorFormSimpleUtil(errors, touched, "password")}
            variant="Password"
          />

          <Button
            text="Entrar"
            color="green"
            fill
            action={submit}
            disabled={!isValid}
            classNames="login-btn"
          />
        </form>
      </div>
    </div>
  );

};

export default Login;
